<!-- Login page - render without app layout -->
<ng-container *ngIf="router.url === '/login'">
  <router-outlet></router-outlet>
</ng-container>

<!-- Main app layout - for all other pages -->
<ng-container *ngIf="router.url !== '/login'">
  <div [class]="layout.config.settings.layout_version">
    <div class="page-wrapper"
         [ngClass]="layout.config.settings.sidebar"
         id="pageWrapper">

      <ng-container *ngIf="userProfile && !isAnona">
        <div class="page-header"
             (scroll)="scrollHandler()"
             [ngStyle]="{ display: show ? 'block' : 'none' }"
             [class.close_icon]="navServices.collapseSidebar">
          <app-header></app-header>
        </div>
      </ng-container>
      <ng-container *ngIf="isAnona">
        <div class="page-header"
             style="margin-left:unset; width:100%; "
             (scroll)="scrollHandler()"
             [ngStyle]="{ display: show ? 'block' : 'none' }"
             [class.close_icon]="navServices.collapseSidebar">
          <app-anona-header></app-anona-header>
        </div>
      </ng-container>

      <!-- Show full layout when loaded -->
      <ng-container *ngIf="isloaded">
        <div class="page-body-wrapper" [class.scorlled]="Scorlled && show == false">
          <div class="sidebar-wrapper"
               *ngIf="!isAnona && userProfile"
               style="height: 100%;"
               [attr.sidebar-layout]="layout.config.settings.sidebar_type"
               [class.close_icon]="navServices.collapseSidebar">
            <app-sidebar *ngIf="userProfile"></app-sidebar>
          </div>
          <div class="page-body"  [ngClass]="{ 'anona': isAnona }"  [@routeAnimations]="prepareRoute(outlet)">
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
          <footer class="footer"
                  *ngIf="!isAnona && userProfile"
                  [class.footer-dark]="footerDark"
                  [class.footer-light]="footerLight"
                  [class.footer-fix]="footerFix">
            <app-footer></app-footer>
          </footer>
        </div>
      </ng-container>
      <!-- Show loading spinner when not loaded -->
      <ng-container *ngIf="!isloaded">
        <div style="text-align: center; margin-top: 100px;">
          <div class="spinner-grow spinner-grow-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>

          <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>


